import en from './en'
import tr from './tr'

export const availableLocales = ['en', 'tr']

export default {
  en,
  tr,
}
